import { useMutation, useQuery } from 'react-query'

import { Report19CreateFormTypes, } from "schemas/report-19-schemas";
import { postReport19Service } from "api/report-19";

export const useReport19Query = (payload: Report19CreateFormTypes) => {
  const query = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useReport19Query', payload],
    queryFn: async () => {
      return await postReport19Service(payload);
    },
  })
  
  return query;
}


export const useReport19Mutation = () => {
  // const queryClient = useQueryClient();
  
  const mutationFn = async (payload: Report19CreateFormTypes) => {
    return await postReport19Service(payload);
  };

  const mutation = useMutation({
    mutationFn,
    // onError: (error: string) => {},
    // onSuccess: (data) => {},
  });

  return mutation;
};
